// extracted by mini-css-extract-plugin
export default {"animateShovel":"ShovelAnimation_animateShovel__ya1HH","dig":"ShovelAnimation_dig__uyhOp","plotContents":"ShovelAnimation_plotContents__eQSKH","hole":"ShovelAnimation_hole__NNyEu"};